module.exports = __webpack_public_path__ + "img/tn-timeline-misc-7.7139809d.jpg";